import { useMutation } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetPermissions = () => {
  const mutation = useMutation(() => {
    return axiosClient.post("/Authentication/GetPermissions");
  });
  return mutation;
};
export default useGetPermissions;
